module.exports = __webpack_public_path__ + "static/media/about-me-small-banner.f752f02e.svg";